import { createContext, type Context } from 'react';

import type { TownsquareApp } from '../types';

type UserProfileCardContextValues = {
	cloudId: string;
	townsquareApp?: TownsquareApp;
	onProfileClick?: (userId: string) => void;
	getTestId: (suffix: string) => string | undefined;
};

/** Sentinel identity used to detect "no outer provider" without an explicit flag. */
const defaultGetTestId: UserProfileCardContextValues['getTestId'] = () => undefined;

const UserProfileCardContext: Context<UserProfileCardContextValues> =
	createContext<UserProfileCardContextValues>({
		cloudId: '',
		townsquareApp: undefined,
		onProfileClick: undefined,
		getTestId: defaultGetTestId,
	});

export { UserProfileCardContext, defaultGetTestId };
export type { UserProfileCardContextValues };
